/**
 * Inline notice for a failed background refetch while cached data is still on
 * screen (PHASE3 §5.6): pages keep rendering the last in-memory rows and only
 * surface the failure as this banner — a full-page ErrorState is reserved for
 * error-with-no-data. Copy mirrors the OfflineBanner's „zuletzt geladene
 * Daten“ contract.
 */

export interface StaleDataNoticeProps {
  onRetry?: () => void;
}

export function StaleDataNotice({ onRetry }: StaleDataNoticeProps) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border-l-4 border-amber-500 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 dark:bg-amber-950/50 dark:text-amber-300">
      <span>Aktualisierung fehlgeschlagen – es werden zuletzt geladene Daten angezeigt.</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 font-semibold underline underline-offset-2 transition-colors duration-150 hover:opacity-80"
        >
          Erneut versuchen
        </button>
      ) : null}
    </div>
  );
}
